import { GridItem, Grid } from 'foundations-components/transitional/components/Grid';
import { RadioInput } from 'foundations-components/transitional/components/RadioInput';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { View } from 'foundations-components/components/View';
import { Image } from 'foundations-components/transitional/components/Image';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CozyCardIllustrationOptions = ({
  options
}) => {
  const illustrations = options.map(({
    illustration,
    key,
    onSelect
  }) => {
    return /*#__PURE__*/_jsx(GridItem, {
      size: {
        xs: 6
      },
      children: /*#__PURE__*/_jsx(TFlex, {
        justify: "center",
        children: /*#__PURE__*/_jsx(View, {
          onClick: onSelect,
          "data-test-id": "image-wrapper",
          cursor: "pointer",
          children: /*#__PURE__*/_jsx(Image, {
            src: illustration,
            role: "img"
          })
        })
      })
    }, key);
  });
  const labelsAndRadioButtons = options.map(({
    label,
    selected,
    onSelect,
    key,
    testSelector
  }) => {
    return /*#__PURE__*/_jsx(GridItem, {
      size: {
        xs: 6
      },
      children: /*#__PURE__*/_jsx(TFlex, {
        align: "center",
        direction: "column",
        children: /*#__PURE__*/_jsx(RadioInput, {
          checked: selected,
          inline: false,
          onChange: onSelect,
          name: `${key}-radio-button`,
          "aria-labelledby": `${key}-label`,
          "data-selenium-test": testSelector,
          children: label
        })
      })
    }, key);
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(View, {
      marginBlockEnd: "400",
      as: "div",
      children: /*#__PURE__*/_jsx(Grid, {
        children: illustrations
      })
    }), /*#__PURE__*/_jsx(Grid, {
      children: labelsAndRadioButtons
    })]
  });
};